import { render, staticRenderFns } from "./ModelCard.vue?vue&type=template&id=4388affe&scoped=true"
import script from "./ModelCard.vue?vue&type=script&lang=js"
export * from "./ModelCard.vue?vue&type=script&lang=js"
import style0 from "./ModelCard.vue?vue&type=style&index=0&id=4388affe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4388affe",
  null
  
)

export default component.exports